import { useTheme } from "@mui/material";

/**
 * * Bold text component
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement} BoldSpanText
 */
export default function BoldSpanText({ children }) {
  const theme = useTheme();
  return (
    <span style={{ fontWeight: "bold", color: theme.palette.primary.main }}>
      {children}
    </span>
  );
}
